
    <br>
    <div class="row">
        <div class="col-sm-12" style="font-weight: 600;text-align: left;">
            <span>Tipo de entrega</span>
        </div>
    </div>
    <br>

    <div class="row">
        <div class="col-sm-2">
        Destino:
        </div>
        <div class="col-sm-3">
            <select class="browser-default custom-select" (change)="onchangeDestino();" [(ngModel)]="cboRegionModel" [disabled]="destinoBloqueado"
                [style.background-color]="destinoBloqueado ? '#e9ecef' : '#ffffff'">
                <option *ngFor="let region of listDestino.response.list" [value]="region.masterId">{{region.masterDescription}}</option>
            </select>
        </div>
        <div class="col-sm-7" [style.display]="displayTipoEntregaRadios">
            <div class="custom-control custom-radio custom-control-inline" *ngFor="let tipoEntrega of tipoEntregaBean.response.list">
                <input type="radio" (change)="onchangeDireccion(tipoEntrega.masterId);" class="custom-control-input" [id]="'tipoentrega'+ tipoEntrega.masterId" name="tipoentrega"
                [(ngModel)]="rdbTipoEntregaVal" [value]="tipoEntrega.masterId" mdbInput>
                <label class="custom-control-label" style="font-size: 15px;" [for]="'tipoentrega'+ tipoEntrega.masterId">{{tipoEntrega.masterDescription}}</label>
            </div>
        </div>
    </div>


    <div [style.display]="displayEnvioInternacional">
        <hr class="w-100">

        <div class="row">
            <div class="col-sm-12" style="font-weight: 600;text-align: left;">
                <span>Datos de envío internacional</span>
            </div>
        </div>
        <br>
        <div class="row form-group">
            <div class="col-sm-6">
                <select class="browser-default custom-select" [(ngModel)]="cboPaisModel">
                    <option value="" selected>País</option>
                    <option *ngFor="let pais of listPais.response.list" [value]="pais.masterId">{{pais.masterDescription}}</option>
                </select>
                <!-- <mdb-error *ngIf="cboDepartamentoValidar.hasError('required') && cboDepartamentoValidar.touched">Seleccione Departamento</mdb-error> -->
            </div>
            <div class="col-sm-6">
                <div class="md-form md-outline">
                <input type="text" id="txtDireccionInternacional" [(ngModel)]="txtDireccionInternacional" maxlength="200" class="form-control" mdbInput>
                <label for="txtDireccionInternacional">Dirección</label>
                </div>
                <!-- <mdb-error *ngIf="txtIdentificadorVal.invalid && (txtIdentificadorVal.dirty || txtIdentificadorVal.touched)">Ingrese el nro de documento</mdb-error> -->
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-12">
                <span style="font-size: 12px;"><b>Nota al cliente:</b>. Al momento de realizar su solicitud de compra desde el exterior, se le notificará el costo de envío y la forma de pago a través de un correo electrónico.</span>
            </div>
        </div>
    </div>

    <hr class="w-100">

    <div [style.display]="displayTipoComprobante">
        <div class="row">
            <div class="col-sm-12" style="font-weight: 600;text-align: left;">
                <span>Tipo de comprobante</span>
            </div>
        </div>
        <br>

        <!-- FORMULARIO PARA PERUANOS -->
        <div class="row" *ngIf="isPeruvian">
        <div class="col-sm-6">

            <div class="row">

                <div class="col-sm-4">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" id="idboleta" name="groupcomprabante"
                        [(ngModel)]="rdbComprobante" (change)="onchangeComprobante()" value="22" mdbInput>
                        <label class="custom-control-label" style="font-size: 15px;" for="idboleta">Boleta</label>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" style="font-size: 15px;" id="txtDNI" [(ngModel)]="txtDNIModel" maxlength="8" placeholder="DNI"
                          aria-describedby="button-addon2">
                        <div class="input-group-append">
                          <button mdbBtn color="primary" (click)="onBuscarDni();" size="sm" class="m-0 px-3 py-2" type="button" id="button-addon2" [disabled]="isLoadingDni"
                            mdbWavesEffect>
                            <mdb-icon *ngIf="!isLoadingDni" fas icon="search"></mdb-icon>
                            <mdb-icon *ngIf="isLoadingDni" fas icon="spinner" class="fa-spin"></mdb-icon>
                          </button>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row justify-content-end">
                <div class="col-sm-8">
                    <!-- Skeleton loader para DNI -->
                    <div *ngIf="isLoadingDni" class="skeleton-wrapper">
                        <div class="skeleton-line"></div>
                    </div>
                    <!-- Campo normal -->
                    <div *ngIf="!isLoadingDni" class="md-form md-outline">
                        <input type="text" id="txtFullName" [style.background-color]="enableManualDniInput ? '#ffffff' : '#e9ecef'" style="font-size:14px" [disabled]="!enableManualDniInput" maxlength="100" [(ngModel)]="txtFullNameModel" class="form-control" mdbInput>
                        <label for="txtFullName" style="background: #e4e4e400;">Apellidos y Nombres{{ enableManualDniInput ? ' (Manual)' : '' }}</label>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6">
            <div class="row">
                <div class="col-sm-4">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" (change)="onchangeComprobante()" class="custom-control-input" id="idfactura" name="groupcomprabante"
                        [(ngModel)]="rdbComprobante" value="23" mdbInput>
                        <label class="custom-control-label" style="font-size: 15px;" for="idfactura">Factura</label>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" style="font-size: 15px;" id="txtRuc" [(ngModel)]="txtRucModel" maxlength="11" placeholder="RUC"
                          aria-describedby="button-addon2">
                        <div class="input-group-append">
                          <button mdbBtn color="primary" size="sm" class="m-0 px-3 py-2" (click)="onBuscarRUC();" type="button" id="button-addon2" [disabled]="isLoadingRuc"
                            mdbWavesEffect>
                            <mdb-icon *ngIf="!isLoadingRuc" fas icon="search"></mdb-icon>
                            <mdb-icon *ngIf="isLoadingRuc" fas icon="spinner" class="fa-spin"></mdb-icon>
                          </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-end">
                <div class="col-sm-8">
                    <!-- Skeleton loader para RUC -->
                    <div *ngIf="isLoadingRuc" class="skeleton-wrapper">
                        <div class="skeleton-line"></div>
                    </div>
                    <!-- Campo normal -->
                    <div *ngIf="!isLoadingRuc" class="md-form md-outline">
                        <input type="text" id="txtRazonSocial" [style.background-color]="enableManualRucInput ? '#ffffff' : '#e9ecef'" style="font-size:14px" [disabled]="!enableManualRucInput" maxlength="100" [(ngModel)]="txtRazonSocialModel" class="form-control" mdbInput>
                        <label for="txtRazonSocial" style="background: #e4e4e400;">Razón Social{{ enableManualRucInput ? ' (Manual)' : '' }}</label>
                    </div>
                </div>
            </div>
        </div>
        </div>

        <!-- FORMULARIO PARA EXTRANJEROS -->
        <div *ngIf="!isPeruvian">
            <div class="row mb-3">
                <div class="col-sm-12">
                    <div class="alert alert-info" style="font-size: 14px; margin-bottom: 0;">
                        <i class="fas fa-globe-americas mr-2"></i>
                        <strong>Visitante internacional:</strong> Detectamos que se encuentra en <strong>{{ detectedCountryName }}</strong>.
                        Complete los siguientes datos para su boleta de venta.
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-sm-4">
                    <label style="font-size: 13px; color: #666;">Tipo de Documento *</label>
                    <select class="browser-default custom-select" [(ngModel)]="cboTipoDocumentoExtranjero" (change)="onChangeTipoDocExtranjero(cboTipoDocumentoExtranjero)">
                        <option value="" selected>Seleccione...</option>
                        <option *ngFor="let tipoDoc of listTipoDocumentoExtranjero?.response?.list" [value]="tipoDoc.masterId">{{tipoDoc.masterDescription}}</option>
                    </select>
                </div>
                <div class="col-sm-4">
                    <label style="font-size: 13px; color: #666;">Número de Documento *</label>
                    <input type="text" class="form-control"
                        [ngClass]="{'is-invalid': errorMsgDocExtranjero}"
                        style="font-size: 15px; text-transform: uppercase;"
                        [(ngModel)]="txtNroDocumentoExtranjero"
                        [maxlength]="maxLengthDocExtranjero"
                        (keypress)="validarDocumentoExtranjero($event)"
                        (blur)="validarDocumentoExtranjeroOnBlur()"
                        [placeholder]="placeholderDocExtranjero">
                    <div *ngIf="errorMsgDocExtranjero" class="invalid-feedback" style="display: block;">
                        {{ errorMsgDocExtranjero }}
                    </div>
                </div>
                <div class="col-sm-4">
                    <label style="font-size: 13px; color: #666;">País de Residencia *</label>
                    <select class="browser-default custom-select" [(ngModel)]="cboPaisResidenciaExtranjero">
                        <option value="" selected>Seleccione país...</option>
                        <option *ngFor="let pais of listPais?.response?.list" [value]="pais.masterId">{{pais.masterDescription}}</option>
                    </select>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-sm-6">
                    <label style="font-size: 13px; color: #666;">Nombre Completo *</label>
                    <input type="text" class="form-control" style="font-size: 15px; text-transform: uppercase;"
                        [(ngModel)]="txtNombreCompletoExtranjero"
                        maxlength="100"
                        placeholder="Nombres y Apellidos">
                </div>
                <div class="col-sm-6">
                    <label style="font-size: 13px; color: #666;">Dirección *</label>
                    <input type="text" class="form-control" style="font-size: 15px; text-transform: uppercase;"
                        [(ngModel)]="txtDireccionExtranjero"
                        maxlength="200"
                        placeholder="Dirección completa">
                </div>
            </div>
        </div>

        <!-- Dirección Fiscal (Solo para peruanos) -->
        <div *ngIf="isPeruvian">
        <hr class="w-100">
        <div class="row">
            <div class="col-sm-12" style="font-weight: 600;text-align: left;">
                <span>Dirección Fiscal</span>
            </div>
        </div>
        <br>
        <div class="row form-group">
            <div class="col-sm-4">
                <select class="browser-default custom-select" [(ngModel)]="cboDepartamentoFiscal" (change)="obtenerProvinciaFiscal(cboDepartamentoFiscal)">
                    <option value="" selected>Departamento *</option>
                    <option *ngFor="let depa of departamento.response.list" [value]="depa.codeDepartment">{{depa.name}}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <select class="browser-default custom-select" [(ngModel)]="cboProvinciaFiscal" (change)="obtenerDistritosFiscal(cboDepartamentoFiscal, cboProvinciaFiscal)">
                    <option value="" selected>Provincia *</option>
                    <option *ngFor="let prov of provinciaFiscal.response.list" [value]="prov.codeProvince">{{prov.name}}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <select class="browser-default custom-select" [(ngModel)]="cboDistritoFiscal">
                    <option value="" selected>Distrito *</option>
                    <option *ngFor="let dist of distritoFiscalResponse.response.list" [value]="dist.codeDistrict">{{dist.name}}</option>
                </select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-12">
                <div class="md-form md-outline">
                    <input type="text" id="txtDireccionFiscalDetalle" [(ngModel)]="txtDireccionFiscalDetalle" maxlength="150" class="form-control" style="text-transform: uppercase;" mdbInput>
                    <label for="txtDireccionFiscalDetalle">Dirección completa (Calle, Número, Departamento) *</label>
                </div>
            </div>
        </div>
        </div>
    </div>

    <br>
    <!-- Checkbox único para Términos y Política de Privacidad -->
    <div class="row">
        <div class="col-sm-12" style="display: flex; justify-content: center; font-size: 17px;">
            <label style="display: flex; align-items: center; gap: 10px; margin: 0; cursor: pointer;">
                <input
                  mdbCheckbox
                  type="checkbox"
                  value=""
                  id="flexCheckTerminosYPolitica"
                  [checked]="flagTerminosCondiciones && flagPoliticaPrivacidad"
                  (change)="onClickCheckboxTerminosYPolitica()"
                  style="width: 18px; height: 18px; min-width: 18px; cursor: pointer; margin: 0;"
                />
                <span>Acepto los <span style="cursor: pointer; text-decoration: underline; color: #c41e3a;" (click)="onClickLinkTerminos(); $event.stopPropagation()">Términos y Condiciones</span> y la <span style="cursor: pointer; text-decoration: underline; color: #c41e3a;" (click)="onClickLinkPoliticaPrivacidad(); $event.stopPropagation()">Política de Privacidad</span></span>
            </label>
        </div>
    </div>
    <div class="row" >
        <div class="col-sm-12" style="text-align: center;font-size:17px">
            <div [style.display]="displayBtnNacional">
            <button class="btn btn-rounded btn-red btn-sm" [disabled]="!isFormularioValido" (click)="onSiguiente();">Siguiente  <i class="fas fa-angle-double-right"></i></button>
            </div>
            <div [style.display]="displayEnvioInternacional">
            <button class="btn btn-rounded btn-yellow btn-sm" (click)="onSolicitarCotizacion();">Solicitar Contización</button>
            </div>
        </div>
    </div>

